import { LimboBetHistoryColumns } from '../../games/limbo/limboCore/constants';
import { MinesBetHistoryColumns } from '../../games/mines/minesCore/constants';
import { DiceBetHistoryColumns } from '../../games/dice/diceCore/constants';
import { HiloBetHistoryColumns } from '../../games/hilo/hiloCore/constants';
import { KenoBetHistoryColumns } from '../../games/keno/kenoCore/constants';
import { AlternativeDiceBetHistoryColumns } from '../../games/alternativeDice/alternativeDiceCore/constants';
import { WheelBetHistoryColumns } from '../../games/wheel/wheelCore/constants';
import { CoinFlipBetHistoryColumns } from '../../games/coinFlip/coinFlipCore/constants';
import { FishingBetHistoryColumns } from '../../games/fishing/fishingCore/constants';
import { BlackJackBetHistoryColumns } from '../../games/blackjack/blackJackCore/constants';
import { BaccaratBetHistoryColumns } from '../../games/baccarat/baccaratCore/constants';
import { FootballBetHistoryColumns } from '../../games/football/footballCore/constants';
import { CrashBetHistoryColumns } from '../../games/crash/crashCore/constants/betsColumns';
import { DriftBetHistoryColumns } from '../../games/drift/driftCore/constants/betsColumns';
import { RouletteBetHistoryColumns } from '../../games/roulette/rouletteCore/constants/tableRows';
import { PlinkoBetHistoryColumns } from '../../games/plinko/plinkoCore/constants/tableRowInfo';
import { DoubleDiceBetHistoryColumns } from '../../games/doubleDice/doubleDiceCore/constants';
import { Limbo10BetHistoryColumns } from '../../games/limbo10/limbo10Core/constants';
import { FastTradeBetHistoryColumns } from '../../games/fastTrade/fastTradeCore/constants';
import { HandBlackJackBetHistoryColumns } from '../../games/handBlackjack/handBlackjackCore/constants';
import { TowerBetHistoryColumns } from '../../games/tower/towerCore/constants';
import { GameIds } from './gameIds';
import { PowerOfGodsBetHistoryColumns } from '../../games/powerOfGods/powerOfGodsCore/constants/globalConstants';

export const BetHistoryColumnByGame = {
  [GameIds.Limbo]: LimboBetHistoryColumns,
  [GameIds.Mines]: MinesBetHistoryColumns,
  [GameIds.Dice]: DiceBetHistoryColumns,
  [GameIds.Hilo]: HiloBetHistoryColumns,
  [GameIds.AlternativeDice]: AlternativeDiceBetHistoryColumns,
  [GameIds.Keno]: KenoBetHistoryColumns,
  [GameIds.Wheel]: WheelBetHistoryColumns,
  [GameIds.CoinFlip]: CoinFlipBetHistoryColumns,
  [GameIds.Crash]: CrashBetHistoryColumns,
  [GameIds.Drift]: DriftBetHistoryColumns,
  [GameIds.Fishing]: FishingBetHistoryColumns,
  [GameIds.BlackJack]: BlackJackBetHistoryColumns,
  [GameIds.Baccarat]: BaccaratBetHistoryColumns,
  [GameIds.Football]: FootballBetHistoryColumns,
  [GameIds.Roulette]: RouletteBetHistoryColumns,
  [GameIds.Plinko]: PlinkoBetHistoryColumns,
  [GameIds.DoubleDice]: DoubleDiceBetHistoryColumns,
  [GameIds.Limbo10]: Limbo10BetHistoryColumns,
  [GameIds.FastTrade]: FastTradeBetHistoryColumns,
  [GameIds.HandBlackJack]: HandBlackJackBetHistoryColumns,
  [GameIds.Tower]: TowerBetHistoryColumns,
  [GameIds.PowerOfGods]: PowerOfGodsBetHistoryColumns,
};
